import React from "react";

const getInitials = (name = "") => {
  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

const AvatarNameBlock = ({
  name = "",
  bgColor = "", // default red-ish
  size = 64,
  textColor = "#fff",
  fontSize = 22
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        fontSize,
        letterSpacing: "-0.12px",
        lineHeight: "12px",
        color: textColor,
        textTransform: "uppercase",
        userSelect: "none"
      }}
    >
      {getInitials(name)}
    </div>
  );
};

export default AvatarNameBlock;
